const brandVariables = {
  data () {
    return {
    }
  },
  computed: {
    brand () {
      return { ...this.$store.getters.getBrandData() }
    }
  }
}

export default brandVariables
